import React, { memo } from "react";

const AllocationTooltip = ({
  title,
  percentage,
  bgColor,
  position,
  changeClass,
}) => {
  return (
    <div
      className={changeClass < 190 ? "change_arrow" : "original_arrow"}
      style={position}
    >
      <div className="title_block_container">
        <span
          className="assets_color_block"
          style={{ backgroundColor: bgColor }}
        >
          {""}
        </span>
        <span className="assets_title">{title}</span>
      </div>

      <span className="allocation">Allocation</span>
      <span className="percentage" style={{ color: bgColor }}>
        {" "}
        {percentage}
      </span>
    </div>
  );
};

export default memo(AllocationTooltip);
